import axios from 'axios';
import { refreshToken } from '../utils/tokenRefresh';
import store from './index';
import { isAuthintecated } from './actions';
import { BASE_URL_SE } from '../../../shared/src/config/api';

const instance = axios.create({
  baseURL: BASE_URL_SE,
  headers: {
    'content-type': 'application/json'
    // 'x-dev-key': 'pUZ`?;SwA11UkeY]!xQ>~6K:{meyL>7fZkr=OEb' //local prod key
  },
  withCredentials: true // Important - enables automatic cookie transmission
});

let isRefreshing = false;
let failedQueue: Array<{ resolve: (value?: any) => void; reject: (reason?: any) => void; config: any }> = [];

const processQueue = (error: any = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(instance(prom.config));
    }
  });
  failedQueue = [];
};

// Response interceptor for handling Unauthorized with silent refresh
instance.interceptors.response.use(
  async (response) => {
    // Check for Unauthorized in response data
    if (
      response.data?.statusCode === 401 ||
      response.data?.message === 'Unauthorized' ||
      response.data?.message?.includes?.('Unauthorized')
    ) {
      const originalRequest = response.config;

      if (!isRefreshing) {
        isRefreshing = true;
        const refreshed = await refreshToken();
        isRefreshing = false;

        if (refreshed) {
          
          processQueue();
          return instance(originalRequest);
        } else {
          // Token refresh failed - set auth state to false
          store.dispatch(isAuthintecated(false));
          processQueue(new Error('Token refresh failed'));
          return response;
        }
      }

      // If already refreshing, queue this request
      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject, config: originalRequest });
      });
    }
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Check for Unauthorized in error response
    if (
      (error.response?.status === 401 ||
        error.response?.data?.statusCode === 401 ||
        error.response?.data?.message === 'Unauthorized') &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;

      if (!isRefreshing) {
        isRefreshing = true;
        const refreshed = await refreshToken();
        isRefreshing = false;

        if (refreshed) {
          processQueue();
          return instance(originalRequest);
        } else {
          // Token refresh failed - set auth state to false
          store.dispatch(isAuthintecated(false));
          processQueue(error);
          return Promise.reject(error);
        }
      }

      return new Promise((resolve, reject) => {
        failedQueue.push({ resolve, reject, config: originalRequest });
      });
    }

    return Promise.reject(error);
  }
);

export default instance;
